import * as React from 'react';

import {
  ApButtonLink,
  ApButtonMain,
  ApModal,
} from '@alixpartners/ui-components';

interface IConfirmModalProps {
  powerBiWorkspaceUrl: string;
  isOpen: boolean;
  onModalClose: () => void;
}

export const ActivateLicenseModal: React.FC<IConfirmModalProps> = ({
  isOpen,
  onModalClose,
  powerBiWorkspaceUrl,
}) => {
  return (
    <ApModal
      className="confirmation-modal"
      header="Anuathorized"
      isOpen={isOpen}
      hasClosed={onModalClose}
      isDismissible={true}
      footer={() => (
        <div className="input-modal__footer">
          <ApButtonLink
            target="_blank"
            rel="noopener noreferrer"
            className="email-link"
            href={powerBiWorkspaceUrl}
          >
            <ApButtonMain>Activate now</ApButtonMain>
          </ApButtonLink>
        </div>
      )}
    >
      <div className="input-modal__content">
        <p>
          To view the Report Site you must first log into a Power BI Workspace
          to activate your license.
        </p>
        <br />
        <p>
          Click Activate now which will take you to this ToolBuilder
          environments report Workspace, log in and then retry here.
        </p>
      </div>
    </ApModal>
  );
};
